export const AF3_INVALID_COORDINATES = {
  VALUE: '32767',
};
